import {
  AppSwitchBox,
  AppTextField,
  AppTextArea,
  AppButton,
  AppUploadBlock,
  AppMultiInputText,
} from 'components';
import ESTDropDownType1 from 'components/molecules/ESTDropDownType1';
import ESDropDown from 'components/molecules/ESDropDown';
import { Fragment, useEffect, useState, useContext } from 'react';
import { UserContext } from 'context/UserContext';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import Joi from 'joi';
import { Link } from 'react-router-dom';
import PlanRatesSpecifier from 'components/molecules/PlanRatesSpecifier';
import { getRandomUid } from 'utilities/uuid.service';
import StreamsDropDown from 'components/molecules/StreamsDropDownType';

function CourseInfo({ editMode, handleSave, details }) {
  const [courseInfo, setCourseInfo] = useState(Object.assign({}, initialState));
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isUk, setIsUk] = useState(false);
  const [disableEdit, setDisableEdit] = useState(editMode);
  const { userPermissions = {} } = useContext(UserContext);

  useEffect(() => {
    if (details?.id) {
      setCourseInfo((x) => ({
        ...x,
        ...details,
        planRates: details?.planRates?.map((x) => ({ planId: x?.plan?._id, price: `${x.rate}` })),
        courseImageFullPath: details?.courseImageUrlFull,
        coursePromoFullPath: details?.coursePromoUrlFull,
        courseSyllabusFullPath: details?.courseSyllabusUrlFull,
        isMonthlyCourse: details?.monthlyCourse,
        monthlyCourse: details?.monthlyCourse,
        yearlyCourse: !details?.monthlyCourse,
        difficultyLevels: details.difficultyLevels.map((x) => ({ ...x, label: x.value })),
        assessmentObjectives: details.assessmentObjectives.map((x) => ({ ...x, label: x.value })),
      }));
    }
  }, [details]);

  function handleInfoChange(data = {}) {
    setCourseInfo((x) => ({ ...x, ...data }));
  }

  function save() {
    if (disableSubmit) return;

    const validation = courseInfoSchema.validate(courseInfo, {
      abortEarly: false,
      allowUnknown: true,
    });
    if (validation?.error) {
      window.alert('Please fill in all the fields.');
      return;
    }

    courseInfo.planRates = courseInfo.planRates.map((x) => ({ plan: x.planId, rate: x.price }));

    handleSave?.({
      ...courseInfo,
      yearlyCourse: !courseInfo.isMonthlyCourse,
      monthlyCourse: courseInfo.isMonthlyCourse,
      difficultyLevels: courseInfo.difficultyLevels.map((x) => ({ value: x.value })),
      assessmentObjectives: courseInfo.assessmentObjectives.map((x) => ({ value: x.value })),
    });
  }

  return (
    <div className="container">
      <Heading editMode={editMode} />

      <div className="row position-relative">
        {disableEdit && (
          <div
            className="position-absolute h-100 w-100"
            style={{ backgroundColor: '#fff', zIndex: 1, opacity: 0.5 }}
          ></div>
        )}
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className=" p-3">
            <AppTextField
              labelProps={{
                label: 'Course Name',
              }}
              inputProps={{
                placeholder: 'Course Name',
                value: courseInfo.courseName,
                onChange: (event) => {
                  const courseName = event.target.value;
                  handleInfoChange({ courseName });
                },
              }}
            />
          </div>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12">
          {/* <div className="w-25 p-3">
            <AppTextField
              labelProps={{
                label: 'Course Name',
              }}
              inputProps={{
                placeholder: 'Course Name',
                value: courseInfo.courseName,
                onChange: (event) => {
                  const courseName = event.target.value;
                  handleInfoChange({ courseName });
                },
              }}
            />
          </div> */}
          <div className="w-25 p-3">
            <ESTDropDownType1
              enableAPI
              value={courseInfo.est}
              handleSelected={(data) => {
                if (data?.key === 'uk') setIsUk(true);
              }}
              handleChange={(event) => {
                const est = event.target.value;
                const __flag = event.target.getAttribute('data-label-key');

                if (__flag === 'uk') setIsUk(true);
                if (__flag !== 'uk') setIsUk(false);

                handleInfoChange({ est });
              }}
            />
          </div>
          <div className="w-25 p-3">
            <ESDropDown
              enableAPI={!!courseInfo.est}
              dependencies={{
                query: courseInfo.est ? `est=${courseInfo.est}` : ``,
              }}
              value={courseInfo.es}
              handleChange={(event) => {
                const es = event.target.value;
                handleInfoChange({ es });
              }}
              defaultLook={false}
            />
          </div>
          <div className="w-25 p-3">
            <StreamsDropDown
              enableAPI={true}
              // dependencies={{
              //   // query: courseInfo.est ? `est=${courseInfo.est}` : ``,
              // }}
              value={courseInfo.stream}
              handleChange={(event) => {
                const stream = event.target.value;
                handleInfoChange({ stream });
              }}
              defaultLook={false}
            />
          </div>
          <div className="w-25 p-3">
            <ESClassDropDown
              enableAPI={!!courseInfo.es}
              dependencies={{
                query: `esId=${courseInfo.es}`,
              }}
              value={courseInfo.classId}
              handleChange={(event) => {
                const classId = event.target.value;
                handleInfoChange({ classId });
              }}
              defaultLook={false}
            />
          </div>
        </div>
        <div className="col-lg-12 col-md-12  col-sm-12">
          <div className="w-25 p-3">
            <AppTextArea
              label="Course Overview"
              areaProps={{
                placeholder: 'Course Overview',
                value: courseInfo.courseOverview,
                onChange: (event) => {
                  const courseOverview = event.target.value;
                  handleInfoChange({ courseOverview });
                },
              }}
            />
          </div>
          <div className="w-25 p-3">
            <AppUploadBlock
              labelProps={{ label: `Course Image` }}
              props={{
                isImage: true,
                isPublic: true,
                uploadCallback: (value) => {
                  setDisableSubmit(value);
                },
                handleChange: (data = {}) => {
                  const { file, fullPath } = data?.uploadedData || {};
                  handleInfoChange({ courseImage: file, courseImageFullPath: fullPath });
                },
                fileData: {
                  fullPath: courseInfo.courseImageFullPath,
                },
              }}
            />
          </div>
          <div className="w-25 p-3">
            <AppUploadBlock
              labelProps={{ label: `Course Promo Video` }}
              props={{
                isVideo: true,
                uploadCallback: (value) => {
                  setDisableSubmit(value);
                },
                handleChange: (data = {}) => {
                  const { file, fullPath } = data?.uploadedData || {};
                  handleInfoChange({ coursePromoUrl: file, coursePromoFullPath: fullPath });
                },
                fileData: {
                  fullPath: courseInfo.coursePromoFullPath,
                },
              }}
            />
          </div>
          <div className="w-25 p-3 tab-nmp">
            <AppUploadBlock
              labelProps={{ label: `Specification/Syllabus` }}
              props={{
                isFile: true,
                uploadCallback: (value) => {
                  setDisableSubmit(value);
                },
                handleChange: (data = {}) => {
                  const { file, fullPath } = data?.uploadedData || {};
                  handleInfoChange({ courseSyllabusUrl: file, courseSyllabusFullPath: fullPath });
                },
                fileData: {
                  fullPath: courseInfo.courseSyllabusFullPath,
                },
              }}
            />
          </div>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="w-25 p-3 ">
            <AppTextArea
              label="Course Contents"
              areaProps={{
                placeholder: 'Course Contents',
                value: courseInfo.courseContent,
                onChange: (event) => {
                  const courseContent = event.target.value;
                  handleInfoChange({ courseContent });
                },
              }}
            />
          </div>
          <div className="w-25 p-3">
            <AppTextField
              labelProps={{
                label: 'Course ID',
              }}
              inputProps={{
                placeholder: 'Course ID',
                value: courseInfo.courseReferenceId,
                onChange: (event) => {
                  const courseReferenceId = event.target.value;
                  handleInfoChange({ courseReferenceId });
                },
              }}
            />
          </div>
          <div className="w-25 p-3 tab-nmp">
            <label className="mr-4" htmlFor="">
              Monthly/Yearly Course
            </label>
            <AppSwitchBox
              labelProps={{
                label: ``,
              }}
              inputProps={{
                value: courseInfo.isMonthlyCourse,
                onChange: (event) => {
                  const { checked } = event.target;
                  handleInfoChange({ isMonthlyCourse: !checked });
                },
              }}
            />
          </div>

          {/* <div className="w-25 p-3 tab-nmp">
            <label className="mr-4" htmlFor="">
              Is this a Drip Course ?
            </label>
            <span className="checkBlock">
              <input id="test3" name="test" value="2" type="checkbox" />
              <label htmlFor="test3"></label>
            </span>

            <div className="w-100 d-flex flex-column ">
              <div className="w-100 mt-4">
                <label htmlFor="">Drip Start Date</label>
                <select required>
                  <option value="" selected="" disabled="">
                    Choose
                  </option>
                  <option value="1">Test</option>
                  <option value="2">Test</option>
                  <option value="3">Test</option>
                </select>
              </div>
              <div className="w-100 mt-4">
                <label htmlFor="">Drip End Date</label>
                <select required>
                  <option value="" selected="" disabled="">
                    Choose
                  </option>
                  <option value="1">Test</option>
                  <option value="2">Test</option>
                  <option value="3">Test</option>
                </select>
              </div>
            </div>
          </div> */}
        </div>

        <div className="col-lg-12 col-md-12 col-sm-12">
          <PlanRatesSpecifier
            planRates={courseInfo.planRates}
            handleChanges={(obj = {}) => {
              let plans = [];
              // check if planId in obj is already in courseInfo.planRates
              // if found then update the price value; else add;
              const planExits = courseInfo.planRates.some((plan) => plan.planId === obj.planId);
              if (planExits) {
                plans = courseInfo.planRates.map((plan) => {
                  if (plan.planId === obj.planId) plan.price = isNaN(obj.price) ? null : obj.price;
                  return plan;
                });
                handleInfoChange({ planRates: plans.filter((x) => x.price) });

                return;
              }
              plans = courseInfo.planRates.concat(obj);
              handleInfoChange({ planRates: plans.filter((x) => x.price) });
            }}
          />
        </div>

        {isUk && (
          <div className="col-12">
            <div className="row">
              <div className="col-6">
                <AppMultiInputText
                  heading={'Difficulty levels'}
                  value={courseInfo.difficultyLevels}
                  setValue={(data) => {
                    handleInfoChange({ difficultyLevels: data });
                  }}
                />
              </div>
              <div className="col-6">
                <AppMultiInputText
                  heading={'Assessment objectives'}
                  value={courseInfo.assessmentObjectives}
                  setValue={(data) => {
                    handleInfoChange({ assessmentObjectives: data });
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row mt-5 btnsubmitmain">
        <div className="col-12 btnTab-foot">
          {!disableEdit && (
            <AppButton variantClass="btn-right-content save" onClick={save}>
              Save Changes
            </AppButton>
          )}
          {disableEdit && userPermissions?.course?.canEditCourseInfo && (
            <AppButton variantClass="btn-right-content prev" onClick={() => setDisableEdit(false)}>
              Edit Course Info
            </AppButton>
          )}
        </div>
      </div>
      {details?.id && (
        <div className="row my-5 pb-3 btnsubmitmain">
          <div className="col-12 btnTab-foot">
            <Link to={`/classes/${details.classId}/courses/${details.id}/chapters`}>
              <AppButton variantClass="btn-right-content next">Add Content</AppButton>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

function Heading({ editMode }) {
  if (editMode)
    return (
      <div className="row">
        <div className="col-12">
          <h2 className="prime-head p-0">Update Course Info</h2>
          <span>Update the course details here</span>
        </div>
      </div>
    );

  return (
    <div className="row">
      <div className="col-12">
        <h2 className="prime-head p-0">Adding Course Info</h2>
        <span>Add the course details here</span>
      </div>
    </div>
  );
}

const initialState = {
  courseName: '',
  classId: '',
  est: '',
  es: '',
  planRates: [],
  status: 'active',
  courseOverview: '',
  courseImage: '',
  courseImageFullPath: '',
  coursePromoUrl: '',
  coursePromoFullPath: '',
  courseSyllabusUrl: '',
  courseSyllabusFullPath: '',
  courseContent: '',
  courseReferenceId: '',
  monthlyCourse: true,
  yearlyCourse: false,
  isMonthlyCourse: false,
  difficultyLevels: [
    { _id: getRandomUid(), label: 'Standard Demand Question', value: 'Standard Demand Question' },
    { _id: getRandomUid(), label: 'High Demand Question', value: 'High Demand Question' },
  ],
  assessmentObjectives: [
    { _id: getRandomUid(), label: 'AO 1', value: 'AO 1' },
    { _id: getRandomUid(), label: 'AO 2', value: 'AO 2' },
    { _id: getRandomUid(), label: 'AO 3', value: 'AO 3' },
  ],
};

const courseInfoSchema = Joi.object({
  courseName: Joi.string().trim(),
  est: Joi.string().trim(),
  es: Joi.string().trim(),
  classId: Joi.string().trim(),
  courseOverview: Joi.string().trim(),
  courseContent: Joi.string().trim(),
  courseReferenceId: Joi.string().trim(),
});

export default CourseInfo;
